import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';

import { Button } from '@repo/components/button';

export function PageError({ msg, retry }: { msg: string; retry?: () => void | Promise<void> }) {
  const router = useRouter();
  const queryErrorResetBoundary = useQueryErrorResetBoundary();

  useEffect(() => {
    queryErrorResetBoundary.reset();
  }, [queryErrorResetBoundary]);

  return (
    <div className="flex flex-col items-start gap-4 mt-4">
      <p>{msg}</p>
      <Button
        action={async () => {
          if (retry) {
            return retry();
          }
          else {
            return router.invalidate();
          }
        }}
      >
        Try again
      </Button>
    </div>
  );
}
